import React from 'react';
import {ScrollToTop} from '../helpers/functions';
import AppRoutes from '../routes/AppRoutes';
import {toast} from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import '../assets/styles/main.scss';

const App = () => {
    toast.configure();

    return (
        <>
            <ScrollToTop/>
            <AppRoutes/>
        </>
    );
};

export default App;
